import { render } from "./QuizQuestion.vue?vue&type=template&id=76d4ae46&scoped=true"
import script from "./QuizQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizQuestion.vue?vue&type=script&lang=ts"

import "./QuizQuestion.vue?vue&type=style&index=0&id=76d4ae46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-76d4ae46"

export default script